import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Snackbar, Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';
// import { ChatResultType } from '../pages/ChatPage';
import { selectUserId } from '../store/features/authSlice';
import { useReportAnswerMutation } from '../store/services/reportApi';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';

interface ICopyToClipboard {
  id: string;
  result: any
}

const CopyToClipboard: React.FC<ICopyToClipboard> = ({ id, result }) => {
  const styles = useStyles()
  const user_id = useSelector(selectUserId)
  const [openSnack, setOpenSnack] = useState(false)
  const [message, setMessage] = useState('')
  const handleToggleSnack = () => setOpenSnack(b => !b)

  const [postReportAnswer, { isLoading, isError, error }] = useReportAnswerMutation<any>()

  const handlePostAnswer = () => {
    postReportAnswer({ user_id, query: result.query, response: JSON.stringify(result.answer) })
  }

  useEffect(() => {
    if (!isLoading && !isError)
      setMessage('Questions and answer reported to developers')

    handleToggleSnack()
  }, [isLoading, isError, error])

  const copyFn = async (target: string) => {
    setMessage('Content copied to clipboard')
    const data = result?.answer[0]?.response_data?.data || []
    let data_copy = data

    if (Array.isArray(data)) {
      const header = JSON.stringify(Object.keys(data[0]))
        .replace(/(^\[)|(\]$)/mg, '') + '\n';
        data_copy = header + data.map(function (d: any) {
        return JSON.stringify(Object.values(d));
      })
        .join('\n')
        .replace(/(^\[)|(\]$)/mg, '');
    }

    await navigator.clipboard.write([
      new ClipboardItem({
        "text/html": new Blob([data_copy], { type: "text/html" }),
        "text/plain": new Blob([data_copy], { type: "text/plain" })
      })
    ]);
    // const _element = document.getElementById(target);
    // const element: HTMLElement = _element!

    // window?.getSelection()!.removeAllRanges();
    // let range = document.createRange();
    // range.selectNode(typeof element === 'string' ? document.getElementById(element)! : element);
    // window.getSelection()!.addRange(range);
    // document.execCommand('copy');
    // window.getSelection()!.removeAllRanges();
    handleToggleSnack()
  };

  return (
    <>
      <hr />
      <div style={{ paddingTop: 10, display: 'flex' }}>
      <Tooltip title="copy" className={styles.copyIconStyle} onClick={() => copyFn(id.toString())}>
          <ContentCopyOutlinedIcon />
        </Tooltip>
        
        <Tooltip title="report to developers" className={styles.emailIconStyle} onClick={handlePostAnswer}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
            <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z" />
            <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
          </svg>
        </Tooltip>
      </div>
      <Snackbar
        open={openSnack}
        autoHideDuration={2000}
        onClose={handleToggleSnack}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        message={message}
      />
    </>)
}

const useStyles = makeStyles(() => ({
  copyIconStyle: {
    '&:hover': {
      fill: 'green',
      Opacity: 0.5,
      color: 'green'
    }
  },
  emailIconStyle: {
    marginLeft: '15px',
    '&:hover': {
      fill: 'green',
      Opacity: 0.5,
      color: 'green'
    }
  }
}))

export default CopyToClipboard